import React, {useEffect,useState,useContext} from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import { IoCloseOutline } from "react-icons/io5";
import { useRef } from 'react';
import SubmitButton from './SubmitButton';
import Message from './Message';

const FormDialog = ({title,children,onSubmit,onClose,version,setVersion}) => {
    const [loading,setLoading] = useState(false);
    const [height,setHeight] = useState(0);
    const [message,setMessage] = useState(null);
    const versionRef = useRef(null);
    const childrenRef = useRef(null);

    useEffect(() => {
      versionRef.current = version;
      const observer = new ResizeObserver(entries => {
          for (let entry of entries) {
              if(childrenRef.current) {
                let maxHeight = window.innerHeight * (90/100);
                if(maxHeight < childrenRef.current.offsetHeight) {
                  setHeight(maxHeight);
                } else {
                  setHeight(0);
                }
              }
          }
      });

      if(childrenRef.current) {
          observer.observe(childrenRef.current)
      }
        
      return () => {
          observer.disconnect();
      };
    },[])
  return (
    <div className={`flex flex-col w-auto max-w-[95%] max-h-[95%] shadow-xl text-sm tracking-wider bg-white rounded-md overflow-hidden`}>
        <div className='flex flex-row w-full items-center justify-between h-10 px-4 shrink-0 text-theme bg-themeLight'>
            <p className='capitalize'>{title}</p>
            <button onClick={onClose} 
                    className='flex w-6 h-6 shrink-0 hover:bg-themeLighter'>
                <IoCloseOutline size={24}/>
            </button>
        </div>
        <div ref={childrenRef} className='flex flex-col space-y-4 w-full h-full p-4 overflow-x-hidden overflow-y-auto'>
            {children}
            {onSubmit && 
              <div className='flex flex-row w-full justify-center shrink-0 space-x-8'>
                <SubmitButton width={128} onSubmit={async (e) => {
                    setLoading(true);
                    let result = await onSubmit(e);
                    setLoading(false);
                    versionRef.current = versionRef.current + 1;
                    setVersion && setVersion(versionRef.current);
                    if(result && result.success) {
                      onClose();
                    } else if(result && result.message) {
                      setMessage({ content: result.message, success: false });
                    } else if(result && result instanceof 'string') {
                      setMessage({ content: result, success: false })
                    } else {
                      setMessage({ content: 'Something went wrong!', success: false })
                    }
                  }}
                  loading={loading}/>
              </div>
            }
            {message && message.content && 
              <Message message={message}/>
            }
        </div>
    </div>
  )
}

export default FormDialog